module.exports = __webpack_public_path__ + "static/media/active_video_thumb2.2a48b2b9.svg";